/* eslint-disable react/prefer-es6-class, react/prop-types, react/jsx-no-bind */
import React from 'react';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';
import Slider from 'es6/components/common/slider';
import * as SoundEffects from 'es6/core/sound-effects';
import SoundManager from 'es6/services/sound-manager';

export const AudioPanel = React.createClass({
  displayName: 'AudioPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('js_iknow.audio settings');
    },
  },

  /**
   * The current soundmanager keeps everything on a scale of 1-10, even though HTML5
   * does it on a scale of 0-1. When the sound manager goes, so can this method.
   */
  _getVolume(setting) {
    return this.props.userSettings.apps[setting] * 10;
  },

  _handleContentClick() {
    SoundManager.play(SoundEffects.CORRECT, { volume: this._getVolume('contentVolume') });
  },

  _handleEffectClick() {
    SoundManager.play(SoundEffects.CORRECT, { volume: this._getVolume('effectVolume') });
  },

  /**
   * Callback for when the typing sound changes.
   *
   * @param {Boolean} typingSound
   */
  _handleTypingSoundChange(typingSound) {
    const attrs = {
      apps: {
        typingSound,
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  /**
   * Because Slider only handles integers and the volume is on a 0 to 1 scale,
   * just adjust from a 1 to 10 scale.
   *
   * @param {String} key
   * @param {Number} value
   */
  _handleVolumeChange(key, value) {
    const attrs = {
      apps: {
        [key]: value / 10,
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  render() {
    const contentVolume = this._getVolume('contentVolume');
    const effectVolume = this._getVolume('effectVolume');
    const typingSound = this.props.userSettings.apps.typingSound;

    return (
      <div className="audio-settings">
        <div className="setting">
          <h4>{t('content volume')}</h4>
          <div className="input">
            <div className="sound glyph glyph-volume-medium sound-player example" onClick={this._handleContentClick}></div>
            <Slider max={10} min={0} onChange={this._handleVolumeChange.bind(null, 'contentVolume')} value={contentVolume} />
          </div>
        </div>

        <div className="setting">
          <h4>{t('effect volume')}</h4>
          <div className="input">
            <div className="sound glyph glyph-volume-medium sound-player example" onClick={this._handleEffectClick}></div>
            <Slider max={10} min={0} onChange={this._handleVolumeChange.bind(null, 'effectVolume')} value={effectVolume} />
          </div>
        </div>

        <div className="setting">
          <h4>{t('typing sound')}</h4>
          {this._renderToggle('typingSound', typingSound, false, this._handleTypingSoundChange)}
        </div>
      </div>
    );
  },
});

export default AudioPanel;
